export default {
  name: 'ZoomImage',
  props: {
    src: { type: String, required: true },
    maxScale: { type: Number, default: 3 }
  },
  data() {
    return {
      scale: 1,
      isZoomed: false,
      wrapperRect: null,
      startDistance: null,
      startScale: 1,
      lastTouch: null // для pan
    };
  },
  methods: {
    // -------------------- Desktop --------------------
    onMouseMove(e) {
      if (this.isTouching) return; // не конфликтовать с touch

      const wrapper = this.$refs.wrapper;
      const img = this.$refs.img;

      if (!this.wrapperRect) this.wrapperRect = wrapper.getBoundingClientRect();

      const { width: w, height: h } = this.wrapperRect;
      const x = e.clientX - this.wrapperRect.left;
      const y = e.clientY - this.wrapperRect.top;

      this.isZoomed = true;
      this.scale = this.maxScale;

      const zoomW = w * this.scale;
      const zoomH = h * this.scale;

      const px = x / w;
      const py = y / h;

      const maxOffsetX = zoomW - w;
      const maxOffsetY = zoomH - h;

      let left = -px * maxOffsetX;
      let top = -py * maxOffsetY;

      left = Math.min(0, Math.max(left, -maxOffsetX));
      top = Math.min(0, Math.max(top, -maxOffsetY));

      img.style.transform = `scale(${this.scale})`;
      img.style.left = left + 'px';
      img.style.top = top + 'px';
      img.style.transformOrigin = '0 0';
    },

    onMouseLeave() {
      if (this.isTouching) return;
      this.resetZoom();
    },

    resetZoom() {
      const img = this.$refs.img;
      this.isZoomed = false;
      this.scale = 1;
      img.style.transform = 'scale(1)';
      img.style.left = '0px';
      img.style.top = '0px';
      img.style.transformOrigin = '50% 50%';
    },

    // -------------------- Touch --------------------
    onTouchStart(e) {
      console.log('onTouchStart');
      this.isTouching = true;

      if (!this.wrapperRect) this.wrapperRect = this.$refs.wrapper.getBoundingClientRect();

      if (e.touches.length === 2) {
        this.startDistance = this.getDistance(e.touches[0], e.touches[1]);
        this.startScale = this.scale;
      } else if (e.touches.length === 1) {
        this.lastTouch = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
    },

    onTouchMove(e) {
      const wrapper = this.$refs.wrapper;
      const img = this.$refs.img;
      const { width: w, height: h } = this.wrapperRect;

      if (e.touches.length === 2) {
        // Pinch zoom
        const distance = this.getDistance(e.touches[0], e.touches[1]);
        let newScale = (distance / this.startDistance) * this.startScale;
        newScale = Math.min(Math.max(newScale, 1), this.maxScale);

        this.scale = newScale;
        this.isZoomed = true;

        const zoomW = w * this.scale;
        const zoomH = h * this.scale;

        // центр пальцев
        const centerX = (e.touches[0].clientX + e.touches[1].clientX) / 2 - this.wrapperRect.left;
        const centerY = (e.touches[0].clientY + e.touches[1].clientY) / 2 - this.wrapperRect.top;

        const px = centerX / w;
        const py = centerY / h;

        const maxOffsetX = zoomW - w;
        const maxOffsetY = zoomH - h;

        let left = -px * maxOffsetX;
        let top = -py * maxOffsetY;

        left = Math.min(0, Math.max(left, -maxOffsetX));
        top = Math.min(0, Math.max(top, -maxOffsetY));

        img.style.transform = `scale(${this.scale})`;
        img.style.left = left + 'px';
        img.style.top = top + 'px';
        img.style.transformOrigin = '0 0';
      } else if (e.touches.length === 1 && this.isZoomed) {
        // Pan
        const touch = e.touches[0];
        const dx = touch.clientX - this.lastTouch.x;
        const dy = touch.clientY - this.lastTouch.y;

        let left = parseFloat(img.style.left || 0) + dx;
        let top = parseFloat(img.style.top || 0) + dy;

        const zoomW = w * this.scale;
        const zoomH = h * this.scale;

        const maxOffsetX = zoomW - w;
        const maxOffsetY = zoomH - h;

        left = Math.min(0, Math.max(left, -maxOffsetX));
        top = Math.min(0, Math.max(top, -maxOffsetY));

        img.style.left = left + 'px';
        img.style.top = top + 'px';

        this.lastTouch = { x: touch.clientX, y: touch.clientY };
      }
    },

    onTouchEnd(e) {
      if (e.touches.length === 0) {
        this.isTouching = false;
        if (this.scale <= 1) this.resetZoom();
      }
    },

    getDistance(touch1, touch2) {
      const dx = touch2.clientX - touch1.clientX;
      const dy = touch2.clientY - touch1.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
  }
};
